import ApiDatabase from 'server';

// Calls of the prospection day. Each one returns a Promise; a rejection keeps
// the axios error, whose response.data.errorCode is read by helper/prospectionErrors.js.
// ApiDatabase is read at call time, so that a test's mock of server/index.js is the one called.
const call = (method, body) =>
  new Promise((resolve, reject) => {
    ApiDatabase[method](body, resolve, reject);
  });

export const openDaySession = () => call('openCrmDaySession', {});

export const getCallDay = () => call('getCrmCallDay', {});

export const getGlobalList = () => call('getCrmGlobalList', {});

export const addToCallDay = ({ companyId, sessionId }) =>
  call('addCrmCallToDay', sessionId ? { companyId, sessionId } : { companyId });

export const listProspects = () => call('getCrmProspects', {});

export const removeFromCallDay = ({ callbackId }) => call('removeCrmCallFromDay', { callbackId });

// The undo object is sent back exactly as the api gave it.
export const restoreToCallDay = (undo) => call('restoreCrmCallToDay', undo);

export const createProspect = ({ fields, addToday }) =>
  call('createCrmProspect', { fields, addToday });

export const checkSirets = async (sirets) => {
  if (!sirets?.length) return [];
  const { followed } = await call('checkCrmProspectSirets', { sirets });
  return followed ?? [];
};
